import { IDeleteObraAreaChecklistUseCase } from "../../../presentation/useCases/delete/delete_obra_area_checklist_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraAreaChecklistUseCase
 */

export class DeleteObraAreaChecklistUseCase implements IDeleteObraAreaChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteObraAreaChecklist(
    idObraAreaChecklist: number,
  ): Promise<void> {
    await this.repository.deleteObraAreaChecklist(
      idObraAreaChecklist,
    );
  }
}
